import React from 'react';
import { Theme }            from '../../../../theme';
import { ComputableColumn, ComputableColumnProps } from '../ComputableColumn/ComputableColumn';
import classNames from 'classnames';
import styles from './GridCell.css';

type GridCellProps = {
    size: number | number[];
    base?: number;
    theme?: Theme;
} & ComputableColumnProps;

export const GridCell = React.memo(({ className, ...props}: GridCellProps) => (
    <ComputableColumn className = {classNames(styles.gridCell, className)} {...props} />
));

GridCell.displayName = 'GridCell';
